export const collectionsPage = {
    'collections.page.title': 'Коллекции',
    'collections.page.bonus.toy.description':
        'Чтобы получить эту особую игрушку, вам нужно завершить всю коллекцию, собрав все остальные игрушки из серии. Как только вы соберёте каждый элемент из набора, эта эксклюзивная игрушка станет доступна в качестве награды, символизируя ваше достижение в завершении полной коллекции.',
    'collections.page.trending.collections.title': 'Популярные коллекции',
}
